import { plural } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { useOpportunityKpiMetrics } from '@/api/opportunity';
import { KpiMetric, KpiMetricGroup } from '@/components/kpi';
import { numberFormat } from '@/helper/numberFormatter';

type Props = {
  opportunityId?: string;
};

const OpportunityDetailKPIMetrics = ({ opportunityId }: Props) => {
  const { opportunityKpiMetrics: data, isLoading, error } = useOpportunityKpiMetrics(opportunityId);

  return (
    <KpiMetricGroup>
      <KpiMetric
        label={<Trans>Opportunity Amount</Trans>}
        value={data && numberFormat(data.revenue, { isCurrency: true, precision: 0 })}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Days Open</Trans>}
        value={data && plural(data.opportunityDaysOpen ?? 0, { one: '# Day', other: '# Days' })}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Visits</Trans>}
        value={data && numberFormat(data.opportunityVisits)}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Non-Digital Events</Trans>}
        value={data && numberFormat(data.opportunityNonDigitalEvents)}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Vendors</Trans>}
        value={data && numberFormat(data.vendorCount)}
        isLoading={isLoading}
        error={error}
      />
    </KpiMetricGroup>
  );
};

export default OpportunityDetailKPIMetrics;
